<template>
	<div :class="[selfPrefix, autoHeight]">
		<div
			class="cls-block"
			:style="`background-image:url(` + data.backImg + `)`"
		>
    <h2><div class="cls-title">服务优势</div></h2>
			<div class="cls-main-home">
				<div class="cls-item" v-for="(item, index) in getListData" :key="index">
					<div class="cls-item-home">
						<div class="cls-name">{{ item.name }}</div>
						<div class="cls-content">{{ item.content }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: "ProductFeatures",
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      prefixCls: "jad-block"
    };
  },
  computed: {
    selfPrefix() {
      return `${this.prefixCls}-product-features`;
    },
    getListData() {
      const { productDataList = [] } = this.data;
      return productDataList;
    },
    autoHeight() {
      const { productDataList = [] } = this.data;
      if (productDataList.length == 4) {
        return "product-features-cls-short-height";
      } else if (productDataList.length == 6) {
        return "product-features-cls-high-height";
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.jad-block-product-features {
  width: 100%;
  background: linear-gradient(180deg, #f0f2ff 0%, #fbfcff 48.13%, white 100%);
  .cls-title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    font-size: 42px;
    font-family: PingFangSC;
    font-weight: 400;
    color: #111;
    }
  .cls-block {
    margin: 0 auto;
    height: 100%;
    padding: 50px;
    width: 1200px;
    background-size: cover;
    position: relative;

    .cls-main-home {
      display: flex;
      flex-wrap: wrap;

      .cls-item {
        display: flex;
        width: 50%;
        height: 174px;
        .cls-item-home {
          margin-bottom: 30px;
          .cls-name {
            margin-bottom: 13px;
            height: 22px;
            font-size: 18px;
            font-family: PingFangSC;
            font-weight: 500;
            color: #333;
            display: flex;
            align-items: center;
            justify-content: left;
            &::before {
              margin-right: 8px;
              display: inline-block;
              content: "";
              width: 6px;
              height: 6px;
              font-size: 12px;
              background: #3247ff;
              border-radius: 50%;
            }
          }
          .cls-content {
            width: 322px;
            font-size: 14px;
            font-family: PingFangSC;
            font-weight: 400;
            color: #666;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            text-align: justify;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
          }
        }
      }
      .cls-item:nth-of-type(2n) {
        justify-content: flex-end;
        .cls-name {
          justify-content: flex-end;
        }
      }
    }
  }
}
.product-features-cls-high-height {
  height: 600px;
}
.product-features-cls-short-height {
  height: 488px;
}
</style>
